import * as React from 'react'

import { BookkeepersCompanyIncidenceStatFragment } from 'generated/resources/graphql'

const IncidenceStatsContext = React.createContext<BookkeepersCompanyIncidenceStatFragment[] | null>(
  null
)
export const IncidenceStatsProvider = IncidenceStatsContext.Provider

export const useIncidenceStats = (): BookkeepersCompanyIncidenceStatFragment[] => {
  const values = React.useContext(IncidenceStatsContext)

  if (!values) {
    throw new Error('useIncidenceStats must be used within an IncidenceStatsProvider')
  }

  return values
}
